export default function filterByUniqueItems<T, K extends keyof T>(
  array: T[],
  keys: K | K[]
): T[] {
  const uniqElements = new Set<string>();
  const keyArray = Array.isArray(keys) ? keys : [keys];

  return array.filter(item => {
    const identifier = keyArray.map(key => String(item[key])).join('|');
    if (uniqElements.has(identifier)) return false;
    else {
      uniqElements.add(identifier);
      return true;
    }
  });
}
